import { useState, useCallback } from 'react'
import { useField } from 'react-final-form'

export default function useHtmlModule(name) {
  const [dataError, setDataError] = useState('')
  const MAX_DATA_LENGTH = 500000

  const dataField = useField(`${name}.data`)
  const data = dataField.input.value || ''

  const validateHtml = useCallback(
    htmlContent => {
      if (!htmlContent || !htmlContent.trim()) {
        return 'HTML content is required'
      }

      if (htmlContent.length > MAX_DATA_LENGTH) {
        return `HTML content must be less than ${MAX_DATA_LENGTH} characters`
      }

      if (htmlContent.includes('<script')) {
        return 'Script tags are not allowed for security reasons'
      }

      return ''
    },
    [MAX_DATA_LENGTH]
  )

  const handleDataChange = useCallback(
    (input, value) => {
      const error = validateHtml(value)
      setDataError(error)

      input.onChange(value)
    },
    [validateHtml]
  )

  return {
    data,
    dataError,
    handleDataChange,
    MAX_DATA_LENGTH
  }
}
